import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadingItems } from "../../redux/actions";
import { itemsSelector } from "../../redux/selectors";
import { useLookup, useSearch, useUrl } from "@ofqual/portal-core/core/hooks";
import { ItemsList } from "./ItemsList";

import { Pager } from "@ofqual/portal-components/components/Pager";
//import { FilterControls } from "./FilterControls";
import { ModuleAppBar } from "../ModuleAppBar";
import { makeStyles } from "@material-ui/core";
import { AppBarButton } from "@ofqual/portal-components/components/SecondaryAppBar";

import { Add } from "@material-ui/icons";
//import { NewCommMenu } from "./NewCommMenu";
import { ListTabs } from "./ListTabs";
import { requestTypeLookupService } from "../../services";
import { FilterControls } from "./FilterControls";
import { NewCommMenu } from "./NewCommsMenu";

const useStyles = makeStyles((theme) => {
  return {
    root: {
      marginTop: theme.contentOffsets.AFTER_SECONDARY_APPBAR,
    },
  };
});

export const Items: React.FC = () => {
  const dispatch = useDispatch();
  const items = useSelector(itemsSelector);
  const { searchParams, navigateToNextPage } = useSearch(useUrl());

  useEffect(() => {
    dispatch(loadingItems(searchParams));
  }, [dispatch, searchParams]);

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState<Element | null>(null);
  const [caoRequestTypeLookups] = useLookup(requestTypeLookupService);

  return (
    <div className={classes.root}>
      <ModuleAppBar>
        <FilterControls />
        <AppBarButton
          onClick={(e) => setAnchorEl(e.currentTarget)}
          text="New"
          data-test="new-communication-button"
          Icon={Add}
          tooltip="New communication"
        />
      </ModuleAppBar>

      <ListTabs />

      <Pager state={items} navigateToNextPage={navigateToNextPage} />

      <div>{items.hasData && <ItemsList state={items} caoRequestTypeLookups={caoRequestTypeLookups} />}</div>

      <NewCommMenu anchorEl={anchorEl} onClose={() => setAnchorEl(null)} />
    </div>
  )
}